import { Outlet } from "react-router-dom";
import "./Checkout.css";

function Checkout() {


    return (
        <div>
            <Outlet />
        </div>
    )
}


export default Checkout;